import { createRoute } from '@tanstack/react-router';
import { lazy } from 'react';
import { authenticatedRoute } from '../_authenticated';

const ApiKeysPage = lazy(() =>
  import('@/features/api-keys/components/ApiKeysPage').then((m) => ({ default: m.ApiKeysPage })),
);

export const apiKeysRoute = createRoute({
  getParentRoute: () => authenticatedRoute,
  path: '/api-keys',
  component: ApiKeysPage,
});
